<template>
  <div class="entrepreneur">
    <div class="border-top" v-if="this.entrepreneurTemp.number || this.edited">
      <div class="text-start" v-if="!edited">
        <div class="p-5" :class="selectedEntrepreneur ? 'border-success' : ''">
          <div class="d-flex justify-content-between mb-1">
            <div class="form-check form-check-custom form-check-solid form-check-sm">
              <label class="form-check-label fw-bold text-primary mb-2 cursor-pointer ms-0" for="selectedEntrepreneur">
                <input v-if="!this.isEdit" class="form-check-input me-1" type="checkbox" id="selectedEntrepreneur" v-model="selectedEntrepreneur"/>
                {{entrepreneurTemp.name ?? entrepreneurTemp.number}}
              </label>
            </div>
            <span class="edit-item" @click="this.edited = !this.edited"><i class="ki-outline ki-notepad-edit"></i></span>
          </div>
          <div class="text-gray-500">
            Номер:
            <span class="float-end text-gray-700 fw-bold" v-html="entrepreneurTemp.number ?? 'Не указан'"></span>
          </div>
          <div class="text-gray-500">
            Адрес:
            <span class="float-end text-gray-700 fw-bold" v-html="entrepreneurTemp.address ?? 'Не указан'"></span>
          </div>
        </div>
      </div>
      <div class="p-5" v-else>
        <input-field
            v-model="entrepreneurTemp.name"
            id="entrepreneur.name"
            name="entrepreneur.name"
            :required="true"
            placeholder="Наименование ИП"
            type="text"
            mb="5"
        />
        <input-field
            v-model="entrepreneurTemp.number"
            id="entrepreneur.number"
            name="entrepreneur.number"
            :required="true"
            placeholder="Номер свидетельства ИП"
            type="text"
            mb="5"
        />
        <input-field
            v-model="entrepreneurTemp.address"
            id="entrepreneur.address"
            name="entrepreneur.address"
            :required="true"
            placeholder="Адрес"
            type="text"
            mb="5"
        />
        <date-field
            v-model="entrepreneurTemp.date"
            id="entrepreneur.date"
            name="entrepreneur.date"
            :required="true"
            placeholder="Дата регистрации ИП"
            mb="5"
        />
        <select-field-from-model
            v-model="entrepreneurTemp.activity_kind_id"
            :required="true"
            id="entrepreneurTemp.activity_kind_name"
            name="entrepreneurTemp.activity_kind_name"
            :options="this.activityKinds"
            placeholder="Код ОКЭД"
            mb="5"
        />
        <div class="row gap-2">
          <button class="col btn btn-sm btn-light-danger btn-block" @click="clear">Очистить</button>
          <button class="col btn btn-sm btn-primary btn-block" @click="save"
                  :disabled="!entrepreneurTemp.name || !entrepreneurTemp.number || !entrepreneurTemp.address || !entrepreneurTemp.date || !entrepreneurTemp.activity_kind_id">Сохранить</button>
        </div>
      </div>
    </div>
    <div class="ps-5 pe-5 pb-5" v-if="this.isEdit ? false : !this.entrepreneurTemp.number && !this.edited">
      <button
          @click="this.edited = !this.edited"
          class="btn btn-sm btn-light-primary btn-block">
        Добавить ИП
      </button>
    </div>
  </div>
</template>

<script>
import InputField     from '@/components/Fields/InputField'
import DateField      from '@/components/Fields/DateField'
import SelectFieldFromModel from "@/components/Fields/SelectFieldFromModel.vue";
import vSelect from "vue-select";

export default {
  name: 'CustomerEntrepreneurs',
  components: {vSelect, SelectFieldFromModel, DateField, InputField },
  props: {
    entrepreneur: null,
    isEdit: {
      type: Boolean,
      default: false
    },
    activityKinds: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      selectedEntrepreneur: false,
      edited:               false,
      entrepreneurTemp: {
        activity_kind_id:    null,
        address:             null,
        number:              null,
        name:                null,
        date:                null,
      }
    }
  },
  methods: {
    clear() {
      if (this.entrepreneur) {
        this.edited           = false
        this.entrepreneurTemp = structuredClone(this.entrepreneur)
      } else {
        this.entrepreneurTemp = {
          activity_kind_id: null,
          address:          null,
          number:           null,
          name:             null,
          date:             null,
        }
        this.selectedEntrepreneur = false
        this.edited               = false
        this.$emit('selectedEntrepreneur', 'undefined')
      }
    },
    save() {
      this.edited = false
      if (this.entrepreneur) this.$emit('selectedEntrepreneur', this.entrepreneurTemp)
    }
  },
  watch: {
    entrepreneur: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.selectedEntrepreneur = true
          this.entrepreneurTemp     = structuredClone(newValue);
        }
      }
    },
    selectedEntrepreneur: {
      immediate: true,
      handler(newValue) {
        this.$emit('selectedEntrepreneur', newValue ? this.entrepreneurTemp : 'undefined')
      }
    }
  }
}
</script>

<style scoped>

</style>